import { useState, Dispatch, SetStateAction } from "react";
import { Modal, Button, TextField } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface ModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function AddEquipment({ open, onClose, setOpen }: ModalProps) {
  const [equipmentName, setEquipmentName] = useState("");
  const [trainingType, setTrainingType] = useState("");
  const [image, setImage] = useState<File | null>(null);
  const [error, setError] = useState(false);

  const handleImageUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      setImage(e.target.files[0]);
    }
  };

  return (
    <Modal
      className="modal addNotification_modal"
      open={open}
      onClose={() => {
        onClose();
        setError(false);
      }}
    >
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>Add Equipment</h2>
            <button
              type="button"
              className="btn-close"
              onClick={() => setOpen(false)}
            >
              <CloseIcon />
            </button>
          </div>

          <form className="form">
            <div className="control_group">
              <TextField
                placeholder="Equipment Name"
                fullWidth
                value={equipmentName}
                onChange={(e) => setEquipmentName(e.target.value)}
                hiddenLabel
              />
              {error && equipmentName === "" && (
                <h6 className="err_msg">Equipment name is required</h6>
              )}
            </div>

            <div className="control_group">
              <TextField
                placeholder="Training Type"
                fullWidth
                value={trainingType}
                onChange={(e) => setTrainingType(e.target.value)}
                hiddenLabel
              />
              {error && trainingType === "" && (
                <h6 className="err_msg">Training type is required</h6>
              )}
            </div>

            <div className="control_group">
              <label>Equipment Image</label>
              <input type="file" onChange={handleImageUpload} />
            </div>

            <div className="footer_btn_flex">
              <Button
                className="btn btn_grey"
                onClick={() => {
                  setError(false);
                  setOpen(false);
                }}
              >
                Cancel
              </Button>

              <Button
                className="btn btn_primary"
                onClick={() => {
                  setError(true);
                  if (equipmentName === "" || trainingType === "") return;

                  // Submit logic here
                  setOpen(false);
                }}
              >
                Submit
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
